import axios from 'axios';
import { getAccessToken, logout } from './auth.js';

export const apiClient = axios.create({
  baseURL: import.meta.env['VITE_API_URL'] ?? '',
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  config.headers.Authorization = `Bearer ${token}`;
  config.headers['x-correlation-id'] = crypto.randomUUID();
  return config;
});

apiClient.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response?.status === 401) {
      await logout();
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export function extractData<T>(res: { data: { data: T } }): T {
  return res.data.data;
}

export function extractList<T>(res: { data: { data: T[]; meta: { count: number } } }): T[] {
  return res.data.data;
}
